module.exports = __webpack_public_path__ + "img/logo-white.02a342d9.svg";